import { compose } from 'recompose';
import { connect } from 'react-redux';

import RecurringErrorMessage from 'components/RecurringErrorMessage/component';

const enhance = compose(connect(() => ({}), {}));

export default enhance(RecurringErrorMessage);
